import {Button, Stack, Typography, useTheme} from '@mui/material';
import React from 'react';

import {AlertInfo} from 'presentation/components/AlertInfo';
import Icon from 'presentation/icons';
import {translations} from 'presentation/translations-new';
import {useContractStatus} from 'presentation/hooks';
import {MyProfileEnum} from 'main/analytics/gaTagsEnum';
import {AlertEnum} from 'presentation/pages/private/profile/store/changeDataAlertStore/types';
import {ContactDataProps} from './types';

const {
	contact: {changeEmail, invalidEmail, withoutEmail},
	successAlert,
	errorAlert,
} = translations['pt-br'].privateFlow.profile.changeData;

const getSuccessMessage = (email?: string) =>
	email
		? `Seu novo e-mail ${email} foi salvo com sucesso. Usaremos ele para enviar avisos do seu plano.`
		: successAlert.account;

const EmailData = ({email, onOpenForm, status, isEmailInvalid}: ContactDataProps) => {
	const {palette} = useTheme();

	const showAlert = status.status && status.type === AlertEnum.EMAIL;
	const {typeMessage} = status;
	const message = {
		success: getSuccessMessage(email),
		error: errorAlert,
	};

	const {isValid, isCancelledAtFiveYears} = useContractStatus();

	return (
		<Stack gap={2}>
			{showAlert ? (
				<AlertInfo.Root severity={typeMessage}>
					<Typography fontSize={'1rem'} fontWeight={600}>
						{message[typeMessage]}
					</Typography>
				</AlertInfo.Root>
			) : null}
			{isEmailInvalid ? (
				<AlertInfo.Root severity="warning">
					<AlertInfo.Description>{invalidEmail}</AlertInfo.Description>
				</AlertInfo.Root>
			) : null}
			<Stack alignItems="center" gap={1} mt={showAlert ? 1 : 0} flexDirection="row">
				<Icon size={24} color={palette.primary.main} name="mail-filled" />
				<Typography color="text.primary">{email || withoutEmail}</Typography>
			</Stack>

			<Stack direction="row" justifyContent="flex-end">
				{isValid || isCancelledAtFiveYears ? (
					<Button
						variant="text"
						onClick={onOpenForm}
						data-tag-id={MyProfileEnum.CLICK_ALTERAR_EMAIL}>
						{changeEmail}
					</Button>
				) : null}
			</Stack>
		</Stack>
	);
};

export {EmailData};
